module.exports = __webpack_public_path__ + "img/logo-1.c8a53bc3.png";